module.exports = __webpack_public_path__ + "img/fide_flag.90dbdbdb.png";